import { MultiSelect } from "components";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { ReactComponent as FiltersIcon } from "assets/icons/filters-icon.svg";
import { useFieldsFiltersContext } from "context/FieldsFiltersProvider";

const FieldsFiltersWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  columnGap: "24px",
  rowGap: "6px",
  "& .multi-select": {
    maxWidth: "300px",
    minWidth: "200px",
    backgroundColor: "white",
  },
});

const FieldsFilters = () => {
  const { t } = useTranslation();
  const {
    filters,
    update,
    clear,
    cropOptions,
    regionOptions,
    prefectureOptions,
  } = useFieldsFiltersContext();

  const handleCropChange = (value) => {
    update({ type: "crops", newFilters: value || [] });
  };

  const handleRegionChange = (value) => {
    update({
      type: "regions",
      newFilters: value,
    });
  };

  const handlePrefectureChange = (value) => {
    update({
      type: "prefectures",
      newFilters: value,
    });
  };

  return (
    <FieldsFiltersWrapper>
      <FiltersIcon
        stroke="black"
        strokeWidth="0.5px"
        fill="white"
        width="30px"
        height="30px"
      />
      <MultiSelect
        options={cropOptions}
        value={filters.crops}
        onChange={handleCropChange}
        placeholder={t("Components.FieldsFilters.Crops", { count: 0 })}
        renderValue={(value) =>
          t("Components.FieldsFilters.Crops", { count: value.length })
        }
        isFullWidth={false}
        className="multi-select"
      />
      <MultiSelect
        options={regionOptions}
        value={filters.regions}
        onChange={handleRegionChange}
        placeholder={t("Components.FieldsFilters.Regions", { count: 0 })}
        renderValue={(value) =>
          t("Components.FieldsFilters.Regions", { count: value.length })
        }
        isFullWidth={false}
        className="multi-select"
      />
      <MultiSelect
        options={prefectureOptions}
        value={filters.prefectures}
        onChange={handlePrefectureChange}
        placeholder={t("Components.FieldsFilters.Prefectures", { count: 0 })}
        renderValue={(value) =>
          t("Components.FieldsFilters.Prefectures", { count: value.length })
        }
        isFullWidth={false}
        className="multi-select"
      />
    </FieldsFiltersWrapper>
  );
};

export default FieldsFilters;
